import { createApi } from '@reduxjs/toolkit/query/react';
import { ApiGetRequest, ApiResponse } from 'types';
import { generateFormData } from 'utils';

import { apiBaseQuery } from 'modules/apiBaseQuery';

import {
  CreateChatPayload,
  FetchMessagesPayload,
  IChat,
  IChatMessage,
  IChatMessagesResponseMeta,
  IChatUser,
  MarkAsReadPayload,
  SendMessagePayload,
} from '../types/app-chat.type';

export const appChatApi = createApi({
  reducerPath: 'appChatApi',
  baseQuery: apiBaseQuery(`${process.env.REACT_APP_API_URL}/v2/api/admin/chats`),
  endpoints: (builder) => ({
    createChat: builder.mutation<ApiResponse<IChat>, CreateChatPayload>({
      query: (payload) => ({
        url: ``,
        method: 'POST',
        body: payload,
      }),
    }),

    fetchChats: builder.query<ApiResponse<IChat[]>, void>({
      query: () => ({
        url: ``,
        method: 'GET',
      }),
    }),

    fetchMessages: builder.query<ApiResponse<IChatMessage[]> & IChatMessagesResponseMeta, FetchMessagesPayload>({
      query: (params) => ({
        url: `/${params.chat_id}/messages`,
        method: 'GET',
        params,
      }),
    }),

    sendMessage: builder.mutation<ApiResponse<IChatMessage>, SendMessagePayload>({
      query: (payload) => ({
        url: `/${payload.chat_id}/messages`,
        method: 'POST',
        body: generateFormData(payload),
      }),
    }),

    markAsRead: builder.mutation<ApiResponse<IChat>, MarkAsReadPayload>({
      query: (payload) => ({
        url: `/${payload.chat_id}/read`,
        method: 'PUT',
        body: payload,
      }),
    }),

    searchUsers: builder.query<ApiResponse<IChatUser[]>, ApiGetRequest>({
      query: (params) => ({
        url: `/users/search`,
        method: 'GET',
        params,
      }),
    }),
  }),
});

export const {
  useLazyFetchMessagesQuery,
  useLazyFetchChatsQuery,
  useCreateChatMutation,
  useSendMessageMutation,
  useMarkAsReadMutation,
  useLazySearchUsersQuery,
} = appChatApi;
